import React, { FC, memo } from 'react'

import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { CountdownEventProps } from '@/types/componentsPropsTypes'

import {
  CounterElem,
  CounterTitle,
  CounterWrapper,
  TextElem,
  TimeElem,
} from './styles'
import { useCountdown } from './useCountdown'

const CounterNodeRaw: FC<{ name: string; value?: number }> = ({
  name,
  value,
}) => {
  const { t } = useCommonTranslation()

  return (
    <CounterElem>
      <TimeElem>{value}</TimeElem>
      <TextElem>{t(name)}</TextElem>
    </CounterElem>
  )
}

const CounterNode = memo(CounterNodeRaw)

export const CountdownEvent: FC<CountdownEventProps> = ({ startTime }) => {
  const remainingTime = useCountdown(startTime) || null
  const { t } = useCommonTranslation()

  return remainingTime ? (
    <div>
      <CounterTitle>{t('startsIn')}</CounterTitle>
      <CounterWrapper>
        <CounterNode name={'counterDays'} value={remainingTime.days} />
        <CounterNode name={'counterHours'} value={remainingTime.hours} />
        <CounterNode name={'counterMinutes'} value={remainingTime.minutes} />
        <CounterNode name={'counterSeconds'} value={remainingTime.seconds} />
      </CounterWrapper>
    </div>
  ) : null
}
